import axios from '@/utils/axios';
import { useCountryStore } from '@/stores/useCountryStore';
import { useStatesStore } from '@/stores/useStatesStore';

export const leadImportConfig = async () => {
 const response = await axios.get(`/lead-import-configs`);
 return response;
};

export const leadImportConfigByPlatform = async (platform) => {
 const response = await axios.get(`/lead-import-configs/platform/${platform}`);
 return response;    
}



export const countries = async () => {
  const store = useCountryStore();
  const list = await store.loadCountries();  
  return { data: { data: list } };
};

export const states = async (country_id) => {
  const store = useStatesStore();
  const data = await store.loadStates(country_id);
  return { data: { data } };
}

export const pincodeWiseAddress = async (pincode) => {
 const response = await axios.get(`/pincode-wise-address/${pincode}`);
 return response;   
}